<main class="d-flex flex-row min-h-full align-items-stretch">
  <div class="flex-1 bg-center bg-cover bg-no-repeat d-none d-md-block"></div>
  <div class="d-flex flex-column flex-1 align-items-center justify-content-center p-3">
    <div class="text-end w-100">
      <!-- Logout Button -->
      <button pButton pRipple type="button" severity="secondary" (click)="logout()">
        <i class="pi pi-sign-out"></i><span class="ms-2">Logout</span>
      </button>
    </div>
    <div class="d-flex flex-column flex-1 align-items-center justify-content-center main-content">
      <div class="logo-container d-flex flex-row">
        <img src="../../../assets/clear_logo.png" width="125px" />
        <cmg-clear2-ui-version-number />
      </div>

      <h6 class="mb-3">Select Security Profile</h6>

      @if (securityProfiles$ | async; as securityProfiles) {
        <form class="p-3 brand-scrollbar w-100">
          @if (!displaySpinner && securityProfiles?.length > 0) {
            @for (securityProfile of securityProfiles; track trackByUserOrgProfileId(i, securityProfile); let i = $index) {
              <div class="d-flex align-items-center gap-2 pb-3">
                <p-radiobutton
                  [formControl]="securityProfileControl"
                  [inputId]="$any(securityProfile.userOrgProfileId)"
                  [value]="securityProfile"
                  name="securityProfile"
                />
                <label [for]="securityProfile.userOrgProfileId" class="text-wrap">
                  <span class="bold">{{ securityProfile.securityProfileName }}</span>
                  ({{ securityProfile.organizationName }})
                </label>
              </div>
            }
          } @else {
            <div class="d-flex flex-column align-items-center justify-content-center security-profile-spinner">
              <img class="spinner mt-auto mb-auto" src="assets/clear_2_loader.gif" width="35%" height="35%" /><span class="mt-auto mb-auto">
                Loading...</span
              >
            </div>
          }
        </form>
      }

      <p-button [disabled]="!securityProfileControl.value" (click)="selectSecurityProfile()" label="Select" class="w-100 my-4" styleClass="w-100" />
    </div>
    <cmg-clear2-ui-login-footer />
  </div>
</main>
